/**
 * An HTML email as readable text, for the one-line preview and the inline
 * "show more" in a conversation.
 *
 * Lives on its own because a receipt is a TABLE: without separators between
 * cells and rows it collapses into "$249.00Add Mineral Blend", which is how
 * her receipts were reading. Kept out of the view so it can be checked
 * directly rather than through a React tree.
 */
export function stripHtmlForPreview(html: string): string {
  const stripped = html
    .replace(/<style[\s\S]*?<\/style>/gi, "")
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<br\s*\/?>(?=)/gi, "\n")
    // A receipt is a table. Without these, "SPEC-VC 15000 MG" "$249.00"
    // "Add Mineral Blend" run into each other as "$249.00Add Mineral
    // Blend", which is exactly how her receipts were reading.
    .replace(/<\/t[dh]>/gi, "  ")
    .replace(/<\/tr>/gi, "\n")
    .replace(/<\/(p|div|li|h\d|table)>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/[ \t]{3,}/g, "  ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
  return stripped;
}
